import {router, usePage} from '@inertiajs/vue3';
import {computed} from 'vue';
import mitt from 'mitt';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

export const schedule_url = 'https://platform.productland.ru/event/2908e87d-ff36-4ff4-bef0-b19490768fce/schedule';
export const schedule_exel = 'https://docs.google.com/spreadsheets/d/1ioniEKI6XV66cEYRoR03MXkrd9GEHX3XOKxdsKZka9A/edit?usp=sharing';

export function translate(str) {

    var ru = {
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
        'е': 'e', 'ё': 'e', 'ж': 'j', 'з': 'z', 'и': 'i',
        'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
        'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
        'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch', 'ш': 'sh',
        'щ': 'shch', 'ы': 'y', 'э': 'e', 'ю': 'u', 'я': 'ya'
    }, n_str = [];

    str = str.replace(/[ъь]+/g, '').replace(/й/g, 'i');

    for (var i = 0; i < str.length; ++i) {
        n_str.push(
            ru[str[i]]
            || ru[str[i].toLowerCase()] == undefined && str[i]
            || ru[str[i].toLowerCase()].toUpperCase()
        );
    }

    return n_str.join('');
}

export const aws_bucket = 'https://productland.s3.eu-central-1.amazonaws.com/';
export const Event = mitt();

export const page = usePage();
export const upcoming_camp = page?.props?.upcoming_camp;

export const base_url_list = {
    video: '/library/multimedia',
    article: '/library/articles',
    tools: '/library/tools',
    courses: '/academy/courses',
};

export const getRandomBanner = computed(() => Math.floor(Math.random() * 2) === 0);

const csrfToken = computed(() => document.querySelector('meta[name="csrf-token"]').getAttribute('content'));

export function togglePublishedAt(model, id) {
    axios.post(route('toggle_published_at'), {
        model: model,
        id: id
    }, {
        headers: {
            'X-CSRF-TOKEN': csrfToken.value
        }
    }).then(response => {
        console.log('response.data router reload');
        router.reload();
    });
}

export function editModel(model, id) {
    console.log('token: ', csrfToken.value);
    axios.post(route('edit_model'), {
        model: model,
        id: id
    }, {
        headers: {
            'X-CSRF-TOKEN': csrfToken.value
        }
    }).then(response => {
        console.log(response.data);
    });
}

export function deleteModel(model, id) {
    axios.post(route('delete_model'), {
        model: model,
        id: id
    }).then(response => {
        console.log(response.data);
        router.reload();
    });
}

export function userImage(user) {
    if (user && user.profile_photo_path) {
        return aws_bucket + user.profile_photo_path;
    }
    if (user.contact && user.contact.avatar) {
        return aws_bucket + user.contact.avatar;
    } else {
        return '/img/empty_user.jpeg';
    }

}

export function checkAccess(input) {
    let out = false;
    input.forEach(role => {
        if (page?.props?.auth?.roles && page?.props?.auth?.roles.map(role => Number(role)).includes(role)) {
            out = true;
        }
    });
    return out;
}

export function rolesIs(input) {
    if (!page.props?.auth?.roles || page.props?.auth?.roles?.length === 0) return false;
    let out = false;

    if (Array.isArray(input)) {
        input.forEach(id => {
            if (!page.props.auth.roles.includes(id)) {
                return;
            }
            out = true;
        });
    } else {
        out = page.props.auth.roles.includes(input);
    }

    return out;
}

export function defineImageUrl(path) {
    return 'https://productland.s3.eu-central-1.amazonaws.com/' + path;
}

export function deleteElement(model, id) {
    // console.log('model, id', model, id, (window.location.pathname.split('/'))[1]);

    let result = confirm(this.$t('library.delete_confirmation'));
    if (result) {
        let url = window.location.pathname;
        if (this.form) {
            this.form.reset();
            url = '/' + (window.location.pathname.split('/'))[1] + '/new';
        }
        router.delete(route(model.toLowerCase() + '.element_destroy', {model: model, id: id, url: url}));
    }
}

export function hideElement(model, id) {
    router.put(route(model.toLowerCase() + '.element_hide', {model: model, id: id}), {
        preserveScroll: true,
        resetOnSuccess: false,
    });
}

export function showElement(model, id) {
    router.put(route(model.toLowerCase() + '.element_show', {model: model, id: id}), {
        preserveScroll: true,
        resetOnSuccess: false,
    });
}

export function sortedType2() {

    return page.props.type_2.sort((a, b) => {
        if (a.name > b.name) {
            return 1;
        }
        if (a.name < b.name) {
            return -1;
        }
        return 0;
    });
}

export let service_route = computed(() => {
    let out = false;
    if (window.location.pathname.indexOf('edit') < 0) {
        out = true;
    }

    return out;
});

export function stepBack() {
    window.history.back();
}

export function proceedLink(path) {
    if (!path || path.length === 0) return;
    window.open(path, '_blank').focus();
}

export function setBackAndProceedLink(href) {
    console.log('inteded');
    // axios.post('/set_intended_url', {
    //         url: window.location.href,
    //     }).then(response => {
    //         console.log(response);
    //         router.get(href);
    //
    //     }).catch(error => {
    //         console.log(error);
    //     });

}

export function redirectLogin() {
    router.get(route('login'));
}

export function distanceFromPageBottom() {
    // return document.documentElement.offsetHeight - document.documentElement.scrollTop - window.innerHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const pageHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
    );

    return pageHeight - (scrollTop + windowHeight);
}

export function copyClipboard(input) {
    const el_clipBoArd = document.createElement('textarea');
    el_clipBoArd.value = input;
    el_clipBoArd.setAttribute('readonly', '');
    el_clipBoArd.style.position = 'absolute';
    el_clipBoArd.style.left = '-9999px';
    document.body.appendChild(el_clipBoArd);
    el_clipBoArd.select();
    document.execCommand('copy');
    document.body.removeChild(el_clipBoArd);
}

export function published(element) {
    return element?.published_at ? dayjs(element.published_at).format('D MMMM') : null;
}

export function setIntededUrl(url) {
    axios.post(route('setIntendedUrl'), {url: url}).then((response) => {
        console.log(response.data);
    });
}

export function redirectWithPreservePosition(link, dto = {}) {
    router.get(link, dto, {
        preserveScroll: true
    });
}

export function goPreviousPage() {
    window.history.back();
}

export const is_auth_user = computed(() => !!page.props?.auth?.user?.id);

export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
